'use client'

import {Box, Divider, Flex, Grid, GridCol, Stack, Text} from '@mantine/core'
import {Sku, SkuHowItWorksContent} from '@/types/interfaces/sku'
import {isMobile} from 'react-device-detect'

export const HowItWorks = ({ sku }: { sku: Sku }) => {
    return renderHowItWorks(sku)
}

function renderHowItWorks(sku: Sku) {
    return (
        <Grid>
            {renderHowItWorksHeader(sku)}
            {renderHowItWorksBody(sku)}
        </Grid>
    )
}

function renderHowItWorksHeader(sku: Sku) {
    return (
        <>
            <GridCol span={12}>
                <Text
                    c={isMobile ? 'var(--Foreground-fg-primary, #1F1E1D)' : 'var(--GM-Text-Black, #181818)'}
                    fw={isMobile ? 450 : 400}
                    fz={isMobile ? 24 : 48}
                    lh={isMobile ? '130%' : '125%'}
                    lts={isMobile ? '-0.24px' : '-1.28px'}
                    flex={'1 0 0'}
                    mb={isMobile ? 0 : 30}
                >
                    How it works
                </Text>

                {!isMobile && <Divider bd={'1px solid var(--gm-foreground-fg-outline-primary)'}/>}
            </GridCol>

            <GridCol span={{ base: 12, md: 6 }}>
                <Text
                    c={isMobile ? 'var(--gm-foreground-fg-secondary, #4F4E4D)' : 'var(--GM-Text-Black, #181818)'}
                    fz={isMobile ? 18 : 30}
                    fw={'var(--weight-text, 500)'}
                    lh={isMobile ? '130%' : '100%'}
                    style={{ alignSelf: 'stretch' }}
                >
                    {sku?.how_it_works_heading}
                </Text>
            </GridCol>
        </>
    )
}

function renderHowItWorksBody(sku: Sku) {
    const lastHowItWorksIndex = sku.how_it_works_content.length - 1
    return (
        <GridCol span={{ base: 12, md: 6 }} pt={30}>
            <Stack gap={30}>
                {sku?.how_it_works_content?.map((content, index) => (
                    <Stack gap={30} key={'how_it_works_content_' + index}>
                        {renderCard(content, index)}
                        {renderDivider(lastHowItWorksIndex, 1)}
                    </Stack>
                ))}
            </Stack>
        </GridCol>
    )
}

function renderCard(content: SkuHowItWorksContent, index: number) {
    return (
        <Flex gap={isMobile ? 0 : 75}>
            <Text
                c={'var(--GM-Text-Black, #181818)'}
                w={45}
                fz={isMobile ? 36 : 64}
                fw={isMobile ? 500 : 400}
                lh={'100%'}
                lts={'-0.72px'}
            >
                {index + 1}
            </Text>

            <Box maw={300}>
                <Text c={'var(--GM-Text-Black, #181818)'} fz={16} fw={750} lh={'150%'}>
                    {content.title}
                </Text>
                <Text c={'var(--GM-Text-Black, #181818)'} fz={16} fw={400} lh={'24px'}>
                    {content.body}
                </Text>
            </Box>
        </Flex>
    )
}

function renderDivider(lastIndex: number, currentIndex: number) {
    const isVisible = lastIndex !== currentIndex || !isMobile
    return (
        isVisible && (
            <Divider size="md"/>
        )
    )
}
